<template>
<div>
  <body>
    <div class="voucher voucher_queenTi">
      <h1 class="read-only">암웨이 퀸 Ti 크라운세트 사은품 교환권 페이지</h1>
      <section class="header">
        <div class="item">
          <img src="./assets/images/queenTi/queenTi_coupon_new.png" alt="암웨이 퀸 Ti 크라운세트 사은품 교환권 (DIA이상 사전 출시 대상) 극세사 디쉬 타올 3종">
        </div>
      </section>
      <coupondetailvue
        :propCouponInfo="this.propCouponInfo"
        :propCouponDetail="this.propCouponDetail"
        :aboInfo="this.aboInfo"
        :couponNo="this.couponNo"
      />
    </div>
  </body>
</div>
</template>
<script>

// Library
import coupondetailvue from './component/coupondetail.vue'
export default {
    metaInfo: {
    title: '암웨이 퀸 Ti 크라운세트 사은품 교환권',
    meta: [
        { 'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8' },
        { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
        { charset:'utf-8' },
        { name:'viewport', content:'width=device-width, initial-scale=1' },
        { name:'keywords'},
        { name:'description', content:'QUEEN Ti'},
        { name:'robots', content:'index,follow'},
        // { property:'og:description', content:'암웨이 퀸 Ti 크라운세트 사은품 교환권 (DIA이상 사전 출시 대상)'},
        { property:'og:image', content:'./assets/images/kakao_thumb_queenTi.png'}
    ]
    },
    name: 'queenti',
    components:{
      coupondetailvue
    },
    props:{
      propCouponInfo: {},
		  propCouponDetail: [],
      aboInfo: {},
      couponNo: ''
    },
    data () {
      return {
        couponInfo: {},
      }
    },
    methods: {
      init: async function () { // 초기화
        this.couponInfo=this.propCouponInfo
      },
    },
    mounted() {
      window.setTimeout(() => {
        this.ready = true
        this.init()
        }, 50)
    },
}
</script>

<style scoped>
    @import './assets/style.css';
</style>



// WEBPACK FOOTER //
// src/views/couponsys/queenti.vue